<!--
    描述：企业申请 -- 审核页
    时间：2022-4-21 16:24:56
    Created by zl
	  updated by 钱磊 2022-4-21 17:51:10
-->
<template>
	<div class="check-layout">
		<el-form :model="addCompanyForm" ref="companyRef" class="addForm" size="small">
			<template v-if="audit == '1002049007'">
				<el-row class="mb20">
					<el-col :span="24">
						<h2>变更前</h2>
					</el-col>
					<el-col :span="24" class="upload-box">
						<el-carousel :autoplay="false" :loop="false" class="w100" height="180px" trigger="click">
							<el-carousel-item class="carousel-item-style" :class="{ justifyContent: applyType == '1' }">
								<div class="upload-item">
									<div class="img-box" :class="{ borderStyle: !dealUrl('baseInfo_1') }">
										<span class="icons">
											<i class="el-icon-zoom-in" @click="doHandler('view', 'baseInfo_1')"></i>
											<i class="el-icon-download" @click="doHandler('download', 'baseInfo_1')"></i>
										</span>
										<img v-if="dealUrl('baseInfo_1')" :src="dealUrl('baseInfo_1')" alt="" />
									</div>
									<div class="top-item-text yyzz">
										{{ dealTitle('baseInfo_1') }}
									</div>
								</div>
								<div class="upload-item" v-if="applyType == '1'">
									<div class="img-box" :class="{ borderStyle: !dealUrl(dlr_assortment.gh) }">
										<span class="icons">
											<i class="el-icon-zoom-in" @click="doHandler('view', dlr_assortment.gh)"></i>
											<i class="el-icon-download" @click="doHandler('download', dlr_assortment.gh)"></i>
										</span>
										<img v-if="dealUrl(dlr_assortment.gh)" :src="dealUrl(dlr_assortment.gh)" alt="" />
									</div>
									<div class="top-item-text yyzz">
										{{ dealTitle(dlr_assortment.gh) }}
									</div>
								</div>
								<div class="upload-item" v-if="applyType == '1'">
									<div class="img-box" :class="{ borderStyle: !dealUrl(dlr_assortment.rx) }">
										<span class="icons">
											<i class="el-icon-zoom-in" @click="doHandler('view', dlr_assortment.rx)"></i>
											<i class="el-icon-download" @click="doHandler('download', dlr_assortment.rx)"></i>
										</span>
										<img v-if="dealUrl(dlr_assortment.rx)" :src="dealUrl(dlr_assortment.rx)" alt="" />
									</div>
									<div class="top-item-text yyzz">
										{{ dealTitle(dlr_assortment.rx) }}
									</div>
								</div>
								<div class="upload-item" v-if="applyType == '1'">
									<div class="img-box" :class="{ borderStyle: !dealUrl('baseInfo_3') }">
										<span class="icons">
											<i class="el-icon-zoom-in" @click="doHandler('view', 'baseInfo_3')"></i>
											<i class="el-icon-download" @click="doHandler('download', 'baseInfo_3')"></i>
										</span>
										<img v-if="dealUrl('baseInfo_3')" :src="dealUrl('baseInfo_3')" alt="" />
									</div>
									<div class="top-item-text yyzz">
										{{ dealTitle('baseInfo_3') }}
									</div>
								</div>
								<div class="upload-item ml20" v-if="applyType == '0'">
									<div class="img-box" :class="{ borderStyle: !dealUrl('baseInfo_2') }">
										<span class="icons">
											<i class="el-icon-zoom-in" @click="doHandler('view', 'baseInfo_2')"></i>
											<i class="el-icon-download" @click="doHandler('download', 'baseInfo_2')"></i>
										</span>
										<img v-if="dealUrl('baseInfo_2')" :src="dealUrl('baseInfo_2')" alt="" />
									</div>
									<div class="top-item-text">{{ dealTitle('baseInfo_2') }}</div>
								</div>
							</el-carousel-item>
							<el-carousel-item v-if="applyType == '1' && !hideAudit">
								<div class="upload-item">
									<div class="img-box" :class="{ borderStyle: !dealUrl('baseInfo_2') }">
										<span class="icons">
											<i class="el-icon-zoom-in" @click="doHandler('view', 'baseInfo_2')"></i>
											<i class="el-icon-download" @click="doHandler('download', 'baseInfo_2')"></i>
										</span>
										<img v-if="dealUrl('baseInfo_2')" :src="dealUrl('baseInfo_2')" alt="" />
									</div>
									<div class="top-item-text">{{ dealTitle('baseInfo_2') }}</div>
								</div>
							</el-carousel-item>
						</el-carousel>
					</el-col>
				</el-row>
				<el-row class="mt20 border-bottom">
					<el-col :span="24">
						<el-form-item label="单位类型：" required>
							{{ addCompanyForm.oldFlatTypeName }}
						</el-form-item>
					</el-col>
					<el-col :span="11">
						<el-form-item label="公司名称：" required>
							<TextTooltip :content="addCompanyForm.oldSname" :refName="'addCompanyFormOldEntName'"></TextTooltip>
						</el-form-item>
					</el-col>
					<el-col :span="12" :offset="1">
						<el-form-item label="统一社会信用代码：" required>
							{{ addCompanyForm.creditCode }}
						</el-form-item>
					</el-col>
					<el-col :span="11">
						<el-form-item label="法人代表姓名：" required>
							{{ addCompanyForm.oldLegal }}
						</el-form-item>
					</el-col>
					<el-col :span="12" :offset="1">
						<el-form-item label="法人代表手机号：" required>
							{{ addCompanyForm.oldLegalPhone }}
						</el-form-item>
					</el-col>
					<el-col :span="11" v-if="this.applyType == '0'">
						<el-form-item label="法人代表证件类型：" required>
							身份证
						</el-form-item>
					</el-col>
					<el-col :span="12" :offset="1" v-if="applyType == '0'">
						<el-form-item label="法人代表身份证号：" required>
							{{ addCompanyForm.oldLegalNo }}
						</el-form-item>
					</el-col>
					<el-col :span="11" v-if="applyType == '1'">
						<el-form-item label="代理人姓名：" required>
							{{ addCompanyForm.oldAgent }}
						</el-form-item>
					</el-col>
					<el-col :span="12" :offset="1" v-if="applyType == '1'">
						<el-form-item label="代理人手机号：" required>
							{{ addCompanyForm.oldAgentPhone }}
						</el-form-item>
					</el-col>
					<el-col :span="11" v-if="applyType == '1'">
						<el-form-item label="代理人证件类型：" required>{{
							addCompanyForm.agentCardTypeName ? addCompanyForm.agentCardTypeName : '身份证'
						}}</el-form-item>
					</el-col>
					<el-col :span="12" :offset="1" v-if="applyType == '1'">
						<el-form-item label="代理人证件号：" required>
							{{ addCompanyForm.oldAgentNo }}
						</el-form-item>
					</el-col>
					<el-col :span="11">
						<el-form-item label="公司简称：" required>
							{{ addCompanyForm.oldShortName }}
						</el-form-item>
					</el-col>
					<el-col :span="12" :offset="1">
						<el-form-item label="注册地址：" required>
							<TextTooltip :content="addCompanyForm.oldRegistAdd" :refName="'addCompanyFormoldRegistAdd'"></TextTooltip>
						</el-form-item>
					</el-col>
				</el-row>
			</template>
			<template>
				<el-row class="mb20">
					<el-col :span="24" v-if="audit == '1002049007'">
						<h2>变更后</h2>
					</el-col>
					<el-col :span="24" class="upload-box">
						<el-carousel :autoplay="false" :loop="false" class="w100" height="180px" trigger="click">
							<el-carousel-item class="carousel-item-style" :class="{ justifyContent: applyType == '1' }">
								<div class="upload-item" v-if="dealTableName != ''">
									<!-- assortment 1 营业执照 -->
									<public-upload
										ref="yyzzUpload"
										isViewMode
										:viewFilesList="chioseFile('baseInfo_1')"
										listType="picture-card"
									></public-upload>
									<div class="top-item-text yyzz">营业执照</div>
								</div>
								<div class="upload-item" v-if="applyType == '1'">
									<!-- assortment 2 代理人身份证（国徽面） -->
									<public-upload
										ref="idCardFUpload"
										isViewMode
										:viewFilesList="chioseFile(dlr_assortment.gh)"
										listType="picture-card"
									></public-upload>
									<div class="top-item-text yyzz">代理人身份证（国徽面）</div>
								</div>
								<div class="upload-item" v-if="applyType == '1'">
									<!-- assortment 3 代理人身份证（人像面） -->

									<public-upload
										ref="idCardZUpload"
										isViewMode
										:viewFilesList="chioseFile(dlr_assortment.rx)"
										listType="picture-card"
									></public-upload>
									<div class="top-item-text yyzz">代理人身份证（人像面）</div>
								</div>
								<div class="upload-item" v-if="applyType == '1' && !hideAudit">
									<!-- assortment 4 企业委托书（盖章） -->
									<public-upload
										ref="sqhUpload"
										isViewMode
										:viewFilesList="chioseFile('baseInfo_3')"
										listType="picture-card"
									></public-upload>
									<div class="top-item-text yyzz">企业委托书（盖章）</div>
								</div>
								<div class="upload-item ml20" v-if="applyType == '0' && !hideAudit">
									<!-- assortment 5 企业logo -->
									<public-upload
										ref="logoUpload"
										isViewMode
										:viewFilesList="chioseFile('baseInfo_2')"
										listType="picture-card"
									></public-upload>
									<div class="logo-style">企业LOGO</div>
								</div>
							</el-carousel-item>
							<el-carousel-item v-if="applyType == '1' && !hideAudit">
								<div class="upload-item">
									<!-- assortment 5 企业logo -->
									<public-upload
										ref="logoUpload"
										isViewMode
										:viewFilesList="chioseFile('baseInfo_2')"
										listType="picture-card"
									></public-upload>

									<div class="logo-style">企业LOGO</div>
								</div>
							</el-carousel-item>
						</el-carousel>
					</el-col>
				</el-row>
				<el-row class="mt20" :class="{ 'border-bottom': audit == '1002049007' && !hideAudit }">
					<el-col :span="24">
						<el-form-item label="单位类型：" required :class="dealClass('oldFlatTypeName', 'flatTypeName')">
							{{ addCompanyForm.flatTypeName }}
						</el-form-item>
					</el-col>
					<el-col :span="11">
						<el-form-item label="公司名称：" required :class="dealClass('oldSname', 'sname')">
							<TextTooltip :content="addCompanyForm.sname" :refName="'addCompanyFormEntName'"></TextTooltip>
						</el-form-item>
					</el-col>
					<el-col :span="12" :offset="1">
						<el-form-item label="统一社会信用代码：" required>
							{{ addCompanyForm.creditCode }}
						</el-form-item>
					</el-col>
					<el-col :span="11">
						<el-form-item label="法人代表姓名：" required :class="dealClass('oldLegal', 'legal')">
							{{ addCompanyForm.legal }}
						</el-form-item>
					</el-col>
					<el-col :span="12" :offset="1">
						<el-form-item label="法人代表手机号：" required :class="dealClass('oldLegalPhone', 'legalPhone')">
							{{ addCompanyForm.legalPhone }}
						</el-form-item>
					</el-col>
					<el-col :span="11" v-if="this.applyType == '0'">
						<el-form-item label="法人代表证件类型：" required>
							身份证
						</el-form-item>
					</el-col>
					<el-col :span="12" :offset="1" v-if="applyType == '0'" :class="dealClass('oldLegalNo', 'legalNo')">
						<el-form-item label="法人代表证件号：" required>
							{{ addCompanyForm.legalNo }}
						</el-form-item>
					</el-col>
					<el-col :span="11" v-if="applyType == '1'">
						<el-form-item label="代理人姓名：" required>
							{{ addCompanyForm.agent }}
						</el-form-item>
					</el-col>
					<el-col :span="12" :offset="1" v-if="applyType == '1'">
						<el-form-item label="代理人手机号：" required>
							{{ addCompanyForm.agentPhone }}
						</el-form-item>
					</el-col>
					<el-col :span="11" v-if="applyType == '1'">
						<el-form-item label="代理人证件类型：" required>{{
							addCompanyForm.agentCardTypeName ? addCompanyForm.agentCardTypeName : '身份证'
						}}</el-form-item>
					</el-col>
					<el-col :span="12" :offset="1" v-if="applyType == '1'">
						<el-form-item label="代理人证件号：" required>
							{{ addCompanyForm.agentNo }}
						</el-form-item>
					</el-col>
					<el-col :span="11">
						<el-form-item label="公司简称：" required :class="dealClass('oldShortName', 'shortName')">
							{{ addCompanyForm.shortName }}
						</el-form-item>
					</el-col>
					<el-col :span="12" :offset="1">
						<el-form-item label="注册地址：" required :class="dealClass('oldRegistAdd', 'registAdd')">
							<TextTooltip :content="addCompanyForm.registAdd" :refName="'addCompanyFormregistAdd'"></TextTooltip>
						</el-form-item>
					</el-col>
				</el-row>
			</template>
			<template v-if="rowData.autoResults != '0' && !isDisabled && !hideAudit">
				<el-col :span="24">
					<div class="red message-box">系统自动审核结果：{{ rowData.autoResults }}</div>
				</el-col>
			</template>
			<el-row :gutter="10" :class="{ 'sp-item': rowData.status === 0 }" v-if="!hideAudit">
				<el-col :span="11" v-if="rowData.status != 0 && !hideAudit">
					<el-form-item label="审核人：" required>
						<span v-if="rowData.auditType">系统自动审核</span>
						<span v-else>{{ rowData.updateUser }}</span>
					</el-form-item>
				</el-col>
				<el-col :span="12" :offset="1" v-if="rowData.status != 0 && !hideAudit">
					<el-form-item label="审核时间：" required>
						<span v-if="rowData.auditType">
							{{ rowData.createDate ? rowData.createDate.substr(0, 11) : '' }}
						</span>
						<span v-else>{{ rowData.updateDate ? rowData.updateDate.substr(0, 11) : '' }}</span>
					</el-form-item>
				</el-col>
				<el-col :span="24" v-if="!hideAudit">
					<el-form-item label="审核结果：" label-width="92px" :rules="[{ required: true, message: '不能为空...' }]" prop="status">
						<el-select v-model="addCompanyForm.status" v-if="rowData.status == 0" placeholder="请选择...">
							<el-option label="审核通过" :value="1"></el-option>
							<el-option label="驳回" :value="2"></el-option>
						</el-select>
						<span v-else>{{ rowData.status == 1 ? '审核通过' : '驳回' }}</span>
					</el-form-item>
				</el-col>
				<el-col :span="24" v-if="!hideAudit">
					<el-form-item
						label="审核意见："
						label-width="92px"
						:rules="[{ required: true, message: '不能为空...', trigger: 'blur' }]"
						prop="remark"
					>
						<el-input
							type="textarea"
							v-if="rowData.status == 0"
							:disabled="isDisabled"
							v-model="addCompanyForm.remark"
							placeholder="请输入..."
							show-word-limit
							maxlength="200"
							:autosize="{ minRows: 4 }"
						></el-input>
						<span v-else>{{ rowData.remark }}</span>
					</el-form-item>
				</el-col>
				<el-col :span="24" v-if="!hideAudit && addCompanyForm.status == 1">
					<el-form-item
						:label="mode == 'view' ? '' : '证明材料：'"
						:label-width="mode == 'view' ? '' : '92px'"
						:class="{ fileFlex: mode == 'view' }"
					>
						<span v-if="mode == 'view'">证明材料：</span>
						<public-upload
							tableName="bus_apply_record"
							assortment="material"
							ref="materialUpload"
							class="id-upload"
							:maxNum="1"
							:aid="rowData.id"
							:class="{ w85: mode == 'view' }"
							:showOtherMsg="true"
							:showQyMsg="true"
							width="600px"
							:mode="mode"
							:needRefresh="false"
							:isDisabled="mode != 'view' ? false : true"
						></public-upload>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>

		<!-- 图片预览 -->
		<el-dialog :visible.sync="previewShow" title="图片预览" append-to-body center>
			<img width="100%" :src="previewPath" alt="" />
		</el-dialog>
	</div>
</template>
<script>
import TextTooltip from '@/views/operation-management/audit-affairs-new/components/TextTooltip'
import { getRecordDetail } from 'api/modules/audit'
import { auditSubmit } from 'api/modules/invoice'
import { mapState } from 'vuex'
import publicUpload from '@/components/w-upload/newUpload'
export default {
	components: {
		TextTooltip,
		publicUpload
	},
	props: {
		viewId: {
			type: String,
			default: ''
		},
		companyId: {
			type: String,
			default: ''
		},
		rowData: {
			type: Object,
			default: () => {
				return {}
			}
		},
		mode: {
			type: String,
			default: ''
		},
		status: {
			type: String,
			default: ''
		},
		hideAudit: {
			type: Boolean,
			default: false
		},
		audit: {
			type: String,
			default: '1002049007'
		}
	},
	data() {
		return {
			addCompanyForm: {
				sname: '', //公司名称
				oldSname: '', //企业名称(原)
				shortName: '', //简称
				oldShortName: '', //企业简称(原)
				creditCode: '', //统一信用码
				legal: '', //法人姓名
				oldLegal: '', //法人代表(原)
				legalNo: '', //法人身份证
				oldLegalNo: '', //法人身份证号(原)
				legalPhone: '', //法人手机号
				oldLegalPhone: '', //法人手机号(原)
				mandateCode: '', //授权码
				registAdd: '', //注册地址
				oldRegistAdd: '', //注册地址(原)
				agent: '', //代理人姓名
				oldAgent: '', //代理人姓名(原)
				agentNo: '', //代理人身份证号
				oldAgentNo: '', //代理人身份证号(原)
				agentPhone: '', //代理人手机号
				oldAgentPhone: '', //代理人手机号(原)
				flatTypeName: '', //单位类型
				oldFlatTypeName: '', //单位类型(原)
				status: '',
				remark: ''
			},
			applyType: '',
			dealTableName: '',
			beforeList: [],
			previewShow: false,
			previewPath: '',
			viewFilesList: [] //图片的回显列表
		}
	},
	created() {
		this.getCompanyMsg()
	},
	methods: {
		// 获取公司信息
		getCompanyMsg() {
			this.addCompanyForm.recordId = this.rowData.id
			this.addCompanyForm.status = this.rowData.status == 0 ? '' : this.rowData.status
			getRecordDetail({
				recordId: this.rowData.id,
				id: this.rowData.id
			}).then((res) => {
				this.viewFilesList = res.data.baseFiles
				this.applyType = res.data.tenantInterim.creType
				this.dealTableName = 'sys_tenant_interim'
				res.data.tenantInterim.status = ''
				res.data.tenantInterim.remark = ''
				this.addCompanyForm = this.$utils.clone(res.data.tenantInterim, true)
				this.addCompanyForm.flatTypeName = this.dealFlatType(res.data.tenantInterim.flatType)
				if (this.mode == 'view') {
					this.addCompanyForm.status = this.rowData.status
				}
				if (this.audit == '1002049007') {
					//1002049007  修改企业   1002049006  创建企业
					this.addCompanyForm.oldFlatTypeName = this.dealFlatType(res.data.tenantInterim.oldFlatType)
					this.beforeList = res.data.oldBaseFiles
				}
			})
		},

		// 审核记录
		checkCompany() {
			this.$refs.companyRef.validate((valid) => {
				if (valid) {
					let params = {
						id: this.rowData.id, //主键id
						busId: this.rowData.busId,
						busType: this.rowData.busType,
						remark: this.addCompanyForm.remark, //审核意见
						status: this.addCompanyForm.status //-审核状态 0：待审核 1：审核通过 2：驳回'
					}
					auditSubmit(params)
						.then((res) => {
							this.$message.success('审核完成')
							this.$emit('closeCompanyDia', 'all')
						})
						.catch((err) => {
							if (err.result) {
								this.$emit('closeCompanyDia', 'only')
							} else {
								this.$emit('closeCompanyDia', 'all')
							}
						})
				} else {
					this.$emit('closeCompanyDia', 'only')
				}
			})
		},

		// 处理查看下载
		doHandler(type, assortment) {
			if (type == 'view') {
				this.previewPath = this.dealUrl(assortment)
				this.previewShow = true
				return
			}
			window.open(this.dealUrl(assortment))
		},

		// 处理码表回显
		dealFlatType(data) {
			let obj = this.projectDict.dwlx.find((x) => x.value == data)
			return obj.sname
		},

		// 处理url
		dealUrl(type) {
			let url = this.$uploadUrl
			let obj = this.beforeList.find((x) => x.assortment == type)
			if (obj) {
				url = url + obj.fileDirectory + obj.serverName
				return url
			}
			return ''
		},

		// 判断图片类型
		chioseFile(Type) {
			let data = {}
			switch (Type) {
				case 'baseInfo_1':
					data = this.viewFilesList.filter((x) => x.assortment == 'baseInfo_1')
					break
				case 'baseInfo_2':
					data = this.viewFilesList.filter((x) => x.assortment == 'baseInfo_2')
					break
				case 'baseInfo_3':
					data = this.viewFilesList.filter((x) => x.assortment == 'baseInfo_3')
					break
				case 'baseInfo_4':
					data = this.viewFilesList.filter((x) => x.assortment == 'baseInfo_4')
					break
				case 'baseInfo_5':
					data = this.viewFilesList.filter((x) => x.assortment == 'baseInfo_5')
					break
				case 'dlr_idcard_1':
					data = this.viewFilesList.filter((x) => x.assortment == 'dlr_idcard_1')
					break
				case 'dlr_idcard_2':
					data = this.viewFilesList.filter((x) => x.assortment == 'dlr_idcard_2')
					break
			}
			return data
		},

		// 处理标题
		dealTitle(data) {
			let msg = ''
			switch (data) {
				case 'baseInfo_1':
					msg = '营业执照'
					break
				case 'baseInfo_2':
					msg = '企业LOGO'
					break
				case 'baseInfo_3':
					msg = '企业委托书（盖章）'
					break
				case 'baseInfo_4':
				case 'dlr_idcard_2':
					msg = '代理人身份证（国徽面）'
					break
				case 'baseInfo_5':
				case 'dlr_idcard_1':
					msg = '代理人身份证（人像面）'
					break
			}
			return msg
		},
		dealClass(oldType, newType) {
			if (this.addCompanyForm[oldType] !== this.addCompanyForm[newType] && this.audit == '1002049007') {
				return 'red'
			}
			return ''
		}
	},
	computed: {
		isDisabled() {
			return this.mode == 'view'
		},
		...mapState('dict', {
			projectDict: (state) => state.projectDict
		}),
		uploadUrl() {
			return this.$uploadUrl
		},
		// 处理回显id --- 暂未用到
		dealId() {
			if (this.audit == '1002049007') {
				//1002049007  修改企业   1002049006  创建企业
				if (this.mode != 'view') {
					return this.viewId
				}
				return this.companyId
			}
			return this.viewId
		},
		// 代理人附件别名
		dlr_assortment() {
			return {
				rx: 'baseInfo_5',
				gh: 'baseInfo_4'
				// rx: this.rowData.isOld == 1 ? 'baseInfo_5' : 'dlr_idcard_1',
				// gh: this.rowData.isOld == 1 ? 'baseInfo_4' : 'dlr_idcard_2'
			}
		}
	}
}
</script>
<style lang="less" scoped>
.check-layout {
	height: 100%;
	.addForm {
		.el-form-item {
			margin-bottom: 5px !important;
		}
	}
	.sp-item {
		.el-form-item {
			margin-bottom: 15px !important;
		}
	}
	.upload-box {
		display: flex;
		margin-top: 15px;
	}
	.upload-item {
		width: 220px;
		height: 150px;
		/deep/ .upload-text {
			vertical-align: middle !important;
		}
	}
	.carousel-item-style {
		display: flex;
	}
	.justifyContent {
		justify-content: space-between;
	}
	.top-item-text {
		font-size: 12px;
		line-height: 30px;
		color: #666;
		text-align: center;
	}
	.yyzz {
		&::before {
			content: '*';
			color: #f56c6c;
			margin-right: 4px;
		}
	}
	.logo-style {
		font-size: 12px;
		line-height: 30px;
		color: #666;
		text-align: center;
	}
	.upload-item {
		width: 210px;
		height: 150px;
		margin-right: 30px;
		/deep/ .upload-text {
			vertical-align: middle !important;
		}
		/deep/.el-upload-list__item {
			width: 210px !important;
			height: 150px !important;
		}
		/deep/.el-upload {
			width: 210px !important;
			height: 150px !important;
		}
		/deep/ .img-size {
			width: 210px !important;
			height: 150px !important;
		}
		/deep/ .el-upload__tip {
			display: none;
		}
	}
	.border-bottom {
		margin-bottom: 20px;
		border-bottom: 5px dashed #2671cc;
	}
	.img-box {
		width: 210px;
		height: 150px;
		background-color: #fbfdff;
		border-radius: 6px;
		position: relative;
		cursor: pointer;
		img {
			width: 100%;
			height: 100%;
			border: 1px solid #eee !important;
			border-radius: 6px;
		}
		.icons {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			display: inline-block;
			text-align: center;
			z-index: 9999;
			color: #fff;
			opacity: 0;
			background-color: rgba(0, 0, 0, 0.5);
			transition: opacity 0.3s;
			border-radius: 6px;
			line-height: 150px;
			i {
				font-size: 20px;
				margin-right: 5px;
				vertical-align: baseline;
			}
		}
	}
	.img-box:hover {
		.icons {
			opacity: 1;
		}
	}
	.borderStyle {
		border: 1px dashed #c0ccda !important;
	}
	.borderStyle:hover {
		border: 1px dashed #2671cc !important;
		.icons {
			opacity: 0 !important;
		}
	}
	.message-box {
		margin: 15px 0;
		height: 40px;
		line-height: 40px;
		background-color: #f2f2f2;
		padding-left: 20px;
		font-size: 13px;
	}
	.red {
		color: red !important;
	}
	.fileFlex {
		/deep/ .el-form-item__content {
			display: flex;
		}
	}
	.w85 {
		width: 85% !important;
	}
}
</style>
